<template>
  <div class="tab-search-bar d-flex flex-wrap align-items-center justify-content-between mb-3">
    <app-tab-switcher
      class="mr-3 mb-2"
      :items="items"
      :value="activeTab"
      @input="$emit('tab-change', $event)"
    />
    <div class="d-flex align-items-center justify-content-end flex-grow-1 ml-3 mb-2">
      <label class="d-none d-lg-block mr-2 mb-0 font-weight-normal">Search</label>
      <div class="tab-search-bar__search">
        <input
          :value="search"
          type="text"
          class="form-control"
          :placeholder="placeholder"
          @input="$emit('search-input', $event.target.value)"
        >
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
          width="16"
          height="16"
          class="tab-search-bar__icon"
        >
          <rect width="100%" height="100%" fill="none" />
          <g>
            <path fill="#231815" d="M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z" />
            <path fill="#231815" d="M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z" />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import AppTabSwitcher from '@/components/AppTabSwitcher'

export default {
  name: 'TabSearchBar',
  components: { AppTabSwitcher },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  }
}
</script>

<style scoped>
.tab-search-bar__search {
  position: relative;
  flex-grow: 1;
  min-width: 220px;
  max-width: 400px;
}

.tab-search-bar__search .form-control {
  width: 100%;
  padding-right: 2rem;
}

.tab-search-bar__icon {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .tab-search-bar {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .tab-search-bar > * {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .tab-search-bar__search {
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TabSearchBar.vue